import Drawer from 'components/commercetools-ui/atoms/drawer';
import StoreSelectorTastic from 'frontastic/tastics/store-selector';
import React, { useCallback, useContext, useState } from 'react';
import { DistributorSelectorContextShape } from './types';
import CloseIcon from '@heroicons/react/24/outline/XMarkIcon';
import { useTranslations } from 'use-intl';

const DistributorSelectorContext = React.createContext<DistributorSelectorContextShape>({
  show() {},
  hide() {},
});

const DistributorSelectorProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const translate = useTranslations();
  const show = useCallback(() => {
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => {
    setIsOpen(false);
  }, []);
  return (
    <>
      <DistributorSelectorContext.Provider value={{ show, hide }}>{children}</DistributorSelectorContext.Provider>
      <Drawer isOpen={isOpen} onClose={hide}>
        <div className="h-full bg-white px-12 py-8">
          <div className="flex items-center justify-between border-b border-neutral-400 py-24 pb-22 pl-12 pr-8 md:pl-22 md:pr-18">
            <div className="flex h-full items-center gap-24">
              <button
                onClick={hide}
                className="cursor-pointer transition hover:opacity-80"
                data-testid="close-icon"
                aria-label={translate('common.close')}
              >
                <CloseIcon className="w-28" stroke="#494949" />
              </button>
            </div>
          </div>
          <StoreSelectorTastic />
        </div>
      </Drawer>
    </>
  );
};

export default DistributorSelectorProvider;

export const useDistributorSelector = () => useContext(DistributorSelectorContext);
